import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '../pipes/translate.pipe';
import { AreaSelectComponent } from '../components/area-select/area-select.component';
import { LabelPipe } from '../pipes/label.pipe';
import { MultiplyPipe } from '../pipes/multiply.pipe';
import { HyphenatePipe } from '../pipes/hyphenate.pipe';
import { LevelNamePipe } from '../pipes/level.pipe';
import { AtlasFixLegendComponent } from '../components/ol-map/ol-map-legend/components/atlas-fix-legend/atlas-fix-legend.component';
import { AtlasMobileLegendComponent } from '../components/ol-map/ol-map-legend/components/atlas-mobile-legend/atlas-mobile-legend.component';
import { AtlasFilterFieldComponent } from '../components/atlas-filter-field/atlas-filter-field.component';

import { MapLegendDirective } from '../components/ol-map/map-legend.directive';
const components = [
    AreaSelectComponent,
    AtlasFilterFieldComponent,
    TranslatePipe,
    AtlasFixLegendComponent,
    AtlasMobileLegendComponent,
    MapLegendDirective,
];

@NgModule({
    declarations: [...components],
    imports: [
        LabelPipe,
        MultiplyPipe,
        HyphenatePipe,
        LevelNamePipe,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSidenavModule,
        MatButtonModule,
        MatRadioModule,
        MatSliderModule,
        LayoutModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatIconModule,
        ScrollingModule,
        MatTableModule,
        MatTooltipModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FontAwesomeModule,
    ],
    exports: [
        MapLegendDirective,
        TranslatePipe,
        LabelPipe,
        MultiplyPipe,
        HyphenatePipe,
        LevelNamePipe,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSidenavModule,
        MatButtonModule,
        MatRadioModule,
        MatSliderModule,
        LayoutModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatIconModule,
        ScrollingModule,
        MatTableModule,
        MatTooltipModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FontAwesomeModule,
        AreaSelectComponent,
        AtlasFilterFieldComponent,
        AtlasFixLegendComponent,
        AtlasMobileLegendComponent,
    ],
})
export class SharedModule {}
